var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import NotificationStack from './notificationStack';
var notificationStackInstance = null;
function newNotificationStackInstance(args, callback) {
    var div = document.createElement('div');
    var called = false;
    document.body.appendChild(div);
    return ReactDOM.render(React.createElement(NotificationStack, { ref: function (notificationStack) {
            if (called) {
                return;
            }
            called = true;
            if (notificationStack) {
                callback({
                    add: function (notificationProps) {
                        notificationStack.add(notificationProps);
                    },
                    component: notificationStack,
                    destroy: function () {
                        if (args.onClose) {
                            args.onClose();
                        }
                        ReactDOM.unmountComponentAtNode(div);
                        div.parentNode.removeChild(div);
                    },
                });
            }
        } }), div);
}
function getNotificationStackInstance(args, callback) {
    if (notificationStackInstance) {
        callback(notificationStackInstance);
        return;
    }
    newNotificationStackInstance(args, function (notificationStack) {
        notificationStackInstance = notificationStack;
        callback(notificationStackInstance);
    });
}
function open(args) {
    getNotificationStackInstance(args, function (notificationStack) {
        notificationStack.add(__assign({}, args));
    });
}
var api = {
    success: function (args) { return open(__assign(__assign({}, args), { type: 'success' })); },
    info: function (args) { return open(__assign(__assign({}, args), { type: 'info' })); },
    warning: function (args) { return open(__assign(__assign({}, args), { type: 'warning' })); },
    error: function (args) { return open(__assign(__assign({}, args), { type: 'error' })); },
};
export default api;
//# sourceMappingURL=index.js.map